import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Login.css';
import AuthServices from '../../services/auth.services';
import { toast } from 'react-toastify';
import { AuthContext } from '../../store/auth';
import { LoaderContext } from '../../store/Loader';
import LanguageSwitcher from '../../LanguageSwitcher';
import translateLanguageImage from '../../assets/Icon material-translate.svg'
import { useTranslation } from 'react-i18next';

import Loader from '../../components/ui/Loader';
import { DocumentContext } from '../../store/document';
import { bgBeforeLogin, textChangeApp, emailPattern } from '../../../src/utils/constants'
import TawqiiaVactorEn from "../../assets/sign_in_vector_tawqiia_en.png"
import TawqiiaVactorAr from "../../assets/sign_in_vector_tawqiia_ar.png"
import TawqiiaLogoEn from "../../assets/Tawqiia_english.png"
import TawqiiaLogoAr from "../../assets/Tawqiia_arabic.png"
import DastkhatVactorEn from "../../assets/dastkat-vactor-img.png"
import DastkhatLogoEnFinalBlue from "../../assets/DastkhatLogoEnFinalBlue.png"
import { useGoogleLogin } from '@react-oauth/google';
import { domainBasedImages, generateSignBanner } from "../../utils/helper";
import Auth from '../../components/Auth/auth';



const authServices = new AuthServices();

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orgName = location.pathname.split('/')[1];
  const { loaderDispatch } = useContext(LoaderContext);
  const { getOrgApp, documentState } = useContext(DocumentContext);
  const { authDispatch, setUserRole, userRole } = useContext(AuthContext);
  const [passwordHide, setPasswordHide] = useState(false);
  const [ldapAccess, setLDAPAccess] = useState(false);
  const [values, setValues] = useState({
    email: '',
    password: '',
    showPassword: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const [logoSrc, setLogoSrc] = useState('');
  const [activeDomain, setActiveDomain]  = useState('')
  const { i18n: { language } } = useTranslation();
  const { t } = useTranslation('login');
  const { t: ts } = useTranslation('apiMessage');

  

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const defaultPrimaryColorValue = localStorage.getItem("defaultPrimaryColor");
  const textChangeAppData = textChangeApp(documentState)

  const dataBg = bgBeforeLogin(documentState)


  useEffect(() => {
    // getOrgApp();
    window.scrollTo(0, 0);
    validateOrgLDAPAccess();
    // handleInitialNavigation();
  }, []);

  let hostname = process.env.REACT_APP_DOMAIN;
  useEffect(() => {
    const language = 'en'; 
    const src = domainBasedImages(hostname, language); 
    setActiveDomain(src)
    setLogoSrc(src);
    setShouldDisplay(hostname === 'TAWQIA');
  }, [hostname, language]);

  const handleInitialNavigation = async () => {
    const tokenString = await localStorage.getItem('jwtToken');
    if (tokenString) {
      navigate(`/${orgName}/dashboard`);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const logo = documentState?.orgAppData;

  const handleLogin = async (e, code) => {
    const { email, password } = values;
    if (e && !code) {
      e.preventDefault();

      switch (true) {
        case !email:
          toast.error(t("emptyEmailValidation"));
          return false;

        case !password:
          toast.error(t("emptyPasswordValidation"));
          return false;
        default:  
      }
    }
    try {
      loaderDispatch({ type: 'SET_LOADING', payload: true });
      setIsLoading(true);
      const data = {
        email,
        password,
        organization: orgName
      };
      if (code) {
        data.code = code;
        delete data.email;
        delete data.password;
      }
      const response = await authServices.login({ ...data });
      const roles = response?.roles
      if (Object.keys(response).length > 0) {
        toast.success(ts('LOGGED_IN'));
        const user = await authServices.getUserProfile(response?.token);
        authDispatch({ type: 'PROFILE', payload: user });
        setUserRole({
          role: response?.roles
        })
        localStorage.setItem("roleData", response?.roles)
        localStorage.setItem('orgName', orgName)
        authServices.authenticate(
          response?.token,
          response?.refresh_token,
          user
        ).then(
          setTimeout(() => {
            const savedRedirect = decodeURIComponent(window.atob(Auth.getNewUrl() || ''));
            const savedUrlPath = savedRedirect.split("/");
            const currentUrlPath = window.location.href.split("/");
            if (currentUrlPath.length >= 2
              && savedUrlPath.length >= 2
              && currentUrlPath[0] === savedUrlPath[0]
              && currentUrlPath[1] === savedUrlPath[1]) {
                Auth.deleteNewUrl();
                window.open(savedRedirect, '_self');
            }else if(logo.logo || roles?.includes('User')){
              navigate(`/${orgName}/dashboard`);
            } else {
              navigate(`/${orgName}/admin`);
            }
          }, 100));
        // fetchUserProfile(response);
      }
    } catch (error) {
      toast.error(ts(`${error.response?.data?.code || error?.response?.data?.message}`));
    } finally {
      setIsLoading(false);
      loaderDispatch({ type: 'SET_LOADING', payload: false });
    }
  };

  const validateOrgLDAPAccess = async () => {
    try {
      const response = await authServices.validatingOrganizationHasLDAPAccess();
      setLDAPAccess(response.data)
    } catch (error) {
      setLDAPAccess(false);
      console.error(error)
    }
  }


  const handleOnChange = (name) => (e) => {
    setValues((prevState) => {
      return { ...prevState, [name]: e.target.value };
    });
  };

  const login = useGoogleLogin({
    onSuccess: codeResponse => handleLogin(null, codeResponse.code),
    flow: 'auth-code',
  });

  // const defaultSecondaryColor = localStorage.getItem("defaultSecondaryColor");
  // `url(${bgImage})`

  const loginOnEnter = (e) => {
    if(e.code === "Enter" || e.code === "NumpadEnter") {
      handleLogin(e);
    }
  }

  return (
    <div className="login-body" style={{
      backgroundImage: dataBg
    }}>
      <div className="login-page">
        <div className="form-submitted">
          <div className="dastkhat-logo">
            <Link to={`/${orgName}`} className={`pointer mt-5 ${!logo?.logo && 'visibility-hidden'}`}>
              <img className="pointer mt-5" src={logo?.logo}
               alt="#" width={130} height={70} />
            </Link>
          </div>
          <div className="sign-vector-section">
            <div>
              {/* <div className="sign-vector">
                <img
                  src={(['ar'].includes(language)&& hostname === 'TAWQIA') ?
                  TawqiiaVactorAr :
                  (['en'].includes(language)&& hostname === 'TAWQIA') ?
                  TawqiiaVactorEn :
                    DastkhatVactorEn}
                  alt="#" />
              </div> */}
              <div className="sign-vector">
                  <img src={generateSignBanner(textChangeAppData, language)} alt='logo' />
              </div>
              <div>
                <img className='dasthkath-logo-login' width={100}  
                src={(['ar'].includes(language)&& hostname === 'TAWQIA') ?
                  TawqiiaLogoAr :
                  (['en'].includes(language)&& hostname === 'TAWQIA') ?
                  TawqiiaLogoEn :
                  DastkhatLogoEnFinalBlue}
                  alt="#" />
              </div>
            </div>

            <div className="login-form">
              <div className="form-here mb-2">
                <div className='d-flex justify-content-between '>
                  <h3 className="bold-text"><strong>{t('heading')}</strong></h3>
                  {/*  */}
                { shouldDisplay && <div className='d-flex justify-content-between align-items-center'><img className='me-2' width={20} src={translateLanguageImage} alt='' />
                    < LanguageSwitcher />
                  </div>}
                  {/*  */}
                </div>
                <div className="form-inputs">
                  <div className="form-input-field">
                    <input
                      value={values.email}
                      onChange={handleOnChange('email')}
                      type="text"
                      placeholder={t('email')}
                      style={{
                        textAlign: `${language === 'ar' ? 'right' : ''}`,
                        direction: `${language === 'ar' ? 'rtl' : ''}`,
                      }}
                    />
                  </div>
                  <div className={`d-flex justify-content-center align-items-center ${language === 'ar' ? 'flex-row-reverse' : ''} form-input-field mt-3`}>
                    <input
                      placeholder={ts('password')}
                      onChange={handleOnChange('password')}
                      style={{
                        textAlign: `${language === 'ar' ? 'right' : ''}`,
                        direction: `${language === 'ar' ? 'rtl' : ''}`,
                      }}
                      value={values.password}
                      type={values.showPassword ? 'text' : 'password'}
                      onKeyDown={loginOnEnter}
                    />
                    <span>
                      <i
                        className={`${!values.showPassword ? `bi bi-eye-slash-fill m-0 p-0 w-100 mx-2 cursor-pointer` : `bi bi-eye-fill eye-icon m-0 p-0 w-100 mx-2 cursor-pointer`}`}
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      ></i>
                    </span>
                    {/* <span>
                    <i class="bi bi-eye-fill eye-icon m-0 p-0 w-100 mx-2 cursor-pointer"></i>
                    </span> */}
                  </div>
                </div>
                <div className={`${language === 'ar' ? 'ar-login-forgetpassword' : 'login-forgetpassword'}`}>
                  <div className="mt-4 respnsive-display" >
                    <Link
                      to={`/${orgName}/forgot-password`}
                      className="forget-paswd"
                    >
                      <p className={`d-flex justify-content-center align-items-center ${language === 'ar' ? 'flex-row-reverse' : ''}`}><span>{t('forgot_pas')}</span><span>?</span></p>
                    </Link>
                  </div>
                  <div className="virtical-line"></div>
                  <div className="login-btn respnsive-login mx-0">
                    <button
                      style={{
                        backgroundColor: textChangeAppData
                      }}
                      className={`${language === 'ar' ? 'ar-btnlogin flex-row-reverse' : 'btnlogin'} mx-3 mt-2 d-flex justify-content-center align-items-center`}
                      onClick={(e) => handleLogin(e)}
                    >
                      <span>{t('loginbtn')}</span><span className='mx-1'>&rarr;</span>
                    </button>
                  </div>
                </div>
                {ldapAccess ? (
                  <>
                    <div class="or-label">
                      <span></span>
                      <span className='text'>{t('or')}</span>
                      <span></span>
                    </div>
                    <div>
                      <button className='google-button' onClick={() => login()}>
                        {t('GOOGLE_BUTTON_LABEL')}
                        <img src="data:image/png;base64,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" alt='GOOGLE_ICON' />
                      </button>
                    </div>
                  </>
                ) : null}
                
                {/* <hr />
                <div className="text-center">
                  {t('ftr_text')}?{' '}
                  <Link to={`/register-company`} style={{ color: 'blue', textDecoration: 'none' }}>
                    {t('create_account')}
                  </Link>

                </div> */}
              </div>
            </div>
          </div >
        </div >
      </div >
      {isLoading && (
        <Loader />
      )}
    </div >
  );
};

export default Login;
